import { RoutesConst } from "../routeConstant";
// /places
var mainPlacesURL = "".concat(RoutesConst.ROOT).concat(RoutesConst.PLACES);
/** Урлы роутов для площадок */
export var RoutesListPlace = {
    /** Список площадок */
    getPlacesList: function () { return mainPlacesURL; },
    /** Детали площадки */
    getPlaceDetails: function (placeId) { return "".concat(mainPlacesURL, "/").concat(placeId); },
    /** Редактирование площадки */
    getPlaceEdit: function (placeId) {
        return "".concat(mainPlacesURL, "/").concat(placeId, "/").concat(RoutesConst.EDIT);
    },
    /** Добавление площадки */
    getPlaceAdd: function () { return "".concat(mainPlacesURL, "/").concat(RoutesConst.ADD); },
    /** Расписания площадки */
    getPlaceSchedules: function (placeId) {
        return "".concat(mainPlacesURL, "/").concat(placeId, "/").concat(RoutesConst.SCHEDULES);
    },
    /** Шаблоны расписаний площадки */
    getPlaceScheduleTemplates: function (placeId) {
        return "".concat(mainPlacesURL, "/").concat(placeId, "/").concat(RoutesConst.SCHEDULE_TEMPLATES);
    },
    /** Добавление расписания */
    getScheduleAdd: function (placeId) {
        return "".concat(mainPlacesURL, "/").concat(placeId, "/").concat(RoutesConst.SCHEDULES, "/").concat(RoutesConst.ADD);
    },
    /** Редактирование расписания */
    getScheduleEdit: function (placeId, scheduleId) {
        return "".concat(mainPlacesURL, "/").concat(placeId, "/").concat(RoutesConst.SCHEDULES, "/").concat(scheduleId, "/").concat(RoutesConst.EDIT);
    },
};
